module.exports = __webpack_public_path__ + "img/pr-10.3b745fe7.png";